import { render, staticRenderFns } from "./CadastroConfiguracaoVendaDadosBasicos.vue?vue&type=template&id=3b751878"
import script from "./CadastroConfiguracaoVendaDadosBasicos.vue?vue&type=script&lang=js"
export * from "./CadastroConfiguracaoVendaDadosBasicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports